export const LINK_SIZES = ['small', 'normal'] as const;
export type TLinkSize = typeof LINK_SIZES[number];

export const LINK_VARIANTS = ['primary', 'secondary'] as const;
export type TLinkVariant = typeof LINK_VARIANTS[number];

export const LINK_ARIA_ATTRIBUTES = ['aria-label'] as const;
export type TLinkAriaAttribute = typeof LINK_ARIA_ATTRIBUTES[number];
